// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"8a3cc09c","245":"8fecb353"}[chunkId] + ".chunk.js";
};